import * as React from "react";
import type { SVGProps } from "react";
const SvgSpaceWidth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 2.4v19.2M2.4 2.4v19.2m13.17-12L18 12m0 0-2.43 2.4M18 12H6m2.43 2.4L6 12m0 0 2.43-2.4"
    />
  </svg>
);
export default SvgSpaceWidth;
